/* BI-04 · DUNNING
   Rule 0 adjacent: gift protection never depends on the merchant’s billing —
   issued gifts stay valid and redeemable whatever happens to the account. */
import { Button, Card, KV, Note } from '@/ui'
import { Head, useBill } from './ParamShell'

export default function BI04Paiement() {
  const d = useBill().dunning
  return (
    <section data-frame="BI-04" style={{ display: 'grid', gap: 14 }}>
      <Head title="Paiement à régulariser" />
      <Note tone="crit">{d.failed}</Note>
      <Card>
        <KV rows={[
          ['Prochain essai', d.retries],
          ['État du compte', <><strong>{d.state}</strong>{d.stateTail}</>],
        ]} />
      </Card>
      <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
        <Button variant="primary" size="sm">Mettre à jour la carte</Button>
        <Button variant="quiet" size="sm">Voir la facture</Button>
      </div>
      <Note tone="ok">
        Quoi qu’il arrive : les cadeaux déjà émis restent valables et validables — la protection
        du cadeau ne dépend jamais de votre facturation.
      </Note>
    </section>
  )
}
